import { CanMatchFn, Route, UrlSegment } from '@angular/router';
import { GetItem, SetItem } from '@core/util/local-storage';
import { Logger } from '@core/logger';
import { VersionReadyEvent } from '@angular/service-worker';

const versionRefreshKey = 'versionRefresh';

export const RefreshGuard: CanMatchFn = async (
	route: Route,
	segments: UrlSegment[],
) => {
	const versionEvent: VersionReadyEvent = GetItem(versionRefreshKey); // Make it strongly typed

	const locationSegments = window.location.pathname.split('/');
	const matterIndex = locationSegments.indexOf('matter');
	const matterId = locationSegments[matterIndex + 1];

	const nextMatterIndex = segments.map((x) => x.path).indexOf('matter');
	const nextMatterId = segments[nextMatterIndex + 1]?.path;

	if (
		(matterId &&
			nextMatterId &&
			matterId !== nextMatterId &&
			segments.some((x) => x.path.includes('matter'))) ||
		segments.some((x) => x.path.includes('create'))
	) {
		Logger.info('GUARD - Skipping refresh for matter or create route...');
		return true;
	}

	if (versionEvent?.type === 'VERSION_READY') {
		// Get full path by joining segments
		const fullPath = segments.map((segment) => segment.path).join('/');

		// If you need the full URL including query params
		const queryParams = segments
			.filter((segment) => segment.parameters)
			.map((segment) => segment.parameters)
			.reduce((acc, params) => ({ ...acc, ...params }), {});

		// Convert query params to string
		const queryString = new URLSearchParams(queryParams).toString();
		const fullDestinationUrl = `${origin}/${fullPath}${queryString ? '?' + queryString : ''}`;

		Logger.info('GUARD - refreshing and routing...', fullDestinationUrl);
		SetItem(versionRefreshKey, null);
		window.location.href = fullDestinationUrl;
		return false;
	}

	return true;
};
